<template>
    <div class="container mt-5">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card">
            <div class="card-header bg-primary text-white">
              <h4 class="text-center">패스워드변경</h4>
            </div>
            <div class="card-body">
              <form @submit.prevent="handleSubmit">
                <div class="mb-3">
                  <label for="old_password" class="form-label">현재패스워드</label>
                  <input
                    type="password"
                    id="old_password"
                    v-model="form.old_password"
                    class="form-control"
                    required
                  />
                </div>
                <div class="mb-3">
                  <label for="new_password1" class="form-label">신규패스워드</label>
                  <input
                    type="password"
                    id="new_password1"
                    v-model="form.new_password1"
                    class="form-control"
                    required
                  />
                </div>
                <div class="mb-3">
                  <label for="new_password2" class="form-label">패스워드확인</label>
                  <input
                    type="password"
                    id="new_password2"
                    v-model="form.new_password2"
                    class="form-control"
                    required
                  />
                </div>
                <div class="d-grid">
                  <button type="submit" class="btn btn-primary">확인</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref } from "vue";
  import { useRouter } from "vue-router";
  import axiosInstance from "@/api/axios"; // Axios 인스턴스 가져오기

  const form = ref({
    old_password: "",
    new_password1: "",
    new_password2: "",
  });
  
  const router = useRouter();
  
  const handleSubmit = async () => {
    if (form.value.new_password1 !== form.value.new_password2) {
      alert("신규 패스워드와 확인 패스워드가  일치 하지 않습니다. ");
      return;
    }
  
    try {
        const response = await axiosInstance.post("change-password/", {
        old_password: form.value.old_password,
        new_password1: form.value.new_password1,
        new_password2: form.value.new_password2,
      });
      alert("패스워드가 변경 되었습니다.!");
      alert(response.data.message); // 서버에서 반환된 메시지 사용

      router.push("/login"); // 비밀번호 변경 후 로그인 화면으로 이동
    } catch (error) {
      alert("패스워드 변경이 실패 하였습니다. 다시 시도하세요.");
      console.error(error);
    }
  };
  </script>
  
  <style scoped>
  .container {
    margin-top: 100px;
  }
  </style>
  